import { db } from '@app/icare/client/db'
import { localQueryOneOptions } from '@app/icare/client/db/client/localQueryOneOptions'
import { patientRelations } from '@app/icare/db/query/patientRelations'
import type { PatientIdType, PatientWithRelations } from '@app/icare/entities/patient/schema/Patient'
import type { UseQueryOptions } from '@tanstack/react-query'

/** Full patient with all hydrated relations */
export const patientQueryOptions = (id: PatientIdType) =>
  localQueryOneOptions({
    query: db
      .selectFrom('patient')
      .selectAll()
      .select(patientRelations.all({ activeOnly: true }))
      .where('patient.id', '=', id),
  })
